<wms-dialog-header title="{{locale.LABEL_BIND + ': ' + bindVariableService.activeProperty.name + ' ' }}"
    subheading="{{bindVariableService.activeProperty.typeLabel || bindVariableService.activeProperty.type}}"
    (onClose)="closeModal()" helpLink="https://docs.wavemaker.com/learn/app-development/variables/variable-binding/"
    helpTitle="{{locale.LABEL_BIND}}">
</wms-dialog-header>
<wms-dialog-body>
  <ng-container *ngIf="!appLocalManagerService.showNewLocaleMsgScreen">
    <div class="content-container">
        <div *ngIf="bindVariableService.variableMode" class="bind-tree-panel">
            <wms-tree (nodeClick)="handleBindTreeNodeClick($event)" sortBy="id" [data]="bindVariableService.bindMapTree"
                [selectedNode]="bindVariableService.selectedNode" iconType="plus">
            </wms-tree>
        </div>
        <tabset class="wm-tabs"
            [ngClass]="{'pull-right': bindVariableService.variableMode, 'pd-0': bindVariableService.variableMode && bindVariableService.isPrefabTemplate}">
            <!--Variable tab-->
            <tab (selectTab)="bindVariableService.setActiveTab(bindVariableService.tabs[0], 0)"
                *ngIf="bindVariableService.shouldLoadTabs && !bindVariableService.isTemplateBundleType"
                [active]="bindVariableService.activeTab.index === 0">
                <ng-template tabHeading class="tab-heading">
                    <span class="bind-tab-labels">{{locale.LABEL_VARIABLE}}</span>
                </ng-template>
                <div class="wm-form">
                    <wms-bind-variable *ngIf="bindVariableService.activeTab.index === 0 || bindVariableService.isVariablesLoaded" (reloadVarTree)="bindVariableService.isVariablesLoaded = false; bindVariableService.defaultAction()"></wms-bind-variable>
                </div>
            </tab>
            <!--Widget Tab-->
            <tab (selectTab)="bindVariableService.setActiveTab(bindVariableService.tabs[1], 1); isWidgetsLoaded=true" *ngIf="bindVariableService.shouldLoadTabs"
                [active]="bindVariableService.activeTab.index === 1">
                <ng-template tabHeading class="tab-heading">
                    <span class="bind-tab-labels">{{locale.LABEL_WIDGETS}}</span>
                </ng-template>
                <div class="wm-form">
                    <wms-bind-widgets *ngIf="bindVariableService.activeTab.index === 1 || isWidgetsLoaded"></wms-bind-widgets>
                </div>
            </tab>
            <!--Resource Tab-->
            <tab (selectTab)="bindVariableService.setActiveTab(bindVariableService.tabs[2], 2)" *ngIf="bindVariableService.shouldLoadTabs"
                [active]="bindVariableService.activeTab.index === 2">
                <ng-template tabHeading class="tab-heading">
                    <span class="bind-tab-labels">{{locale.LABEL_RESOURCE}}</span>
                </ng-template>
                <div class="wm-form">
                    <wms-bind-resource *ngIf="bindVariableService.activeTab.index === 2"></wms-bind-resource>
                </div>
            </tab>
            <!--Use Expression Tab-->
            <tab (selectTab)="bindVariableService.setActiveTab(bindVariableService.tabs[3], 3); isExprLoaded = true" *ngIf="bindVariableService.shouldLoadTabs"
                [active]="bindVariableService.activeTab.index === 3">
                <ng-template tabHeading class="tab-heading">
                    <span class="bind-tab-labels">{{locale.LABEL_BIND_USE_EXPRESSION}}</span>
                </ng-template>
                <wms-bind-use-expression *ngIf="bindVariableService.activeTab.index === 3 || isExprLoaded" [isloaded]="bindVariableService.activeTab.index === 3"></wms-bind-use-expression>
            </tab>
            <!--Localized Messages Tab-->
            <tab (selectTab)="bindVariableService.setActiveTab(bindVariableService.tabs[4], 4)" *ngIf="bindVariableService.shouldLoadTabs"
                [active]="bindVariableService.activeTab.index === 4">
                <ng-template tabHeading class="tab-heading">
                    <span class="bind-tab-labels">{{locale.LABEL_APP_MESSAGES}}</span>
                </ng-template>
                <div class="wm-form">
                    <wms-bind-localized-messages *ngIf="bindVariableService.activeTab.index === 4 || bindVariableService.appMessagesInitialized"></wms-bind-localized-messages>
                </div>
            </tab>
            <!--Prefab Properties Tab-->
            <tab (selectTab)="bindVariableService.setActiveTab(bindVariableService.tabs[5], 5)"
                 *ngIf="bindVariableService.shouldLoadTabs && bindVariableService.isPrefabTemplate"
                 [active]="bindVariableService.activeTab.index === 5">
              <ng-template tabHeading class="tab-heading">
                <span class="bind-tab-labels">{{locale.LABEL_PREFAB_PROPERTIES}}</span>
              </ng-template>
              <div class="wm-form">
                <wms-bind-prefab-properties *ngIf="bindVariableService.activeTab.index === 5"></wms-bind-prefab-properties>
              </div>
            </tab>
            <!-- Page Params Tab - bind to page input properties (displayed only if page has inputs defined)-->
            <tab (selectTab)="bindVariableService.setActiveTab(bindVariableService.isPrefabTemplate ? bindVariableService.tabs[6] : bindVariableService.tabs[5], bindVariableService.isPrefabTemplate ? 6 : 5)"
                [active]="bindVariableService.activeTab.index === (bindVariableService.isPrefabTemplate ? 6 : 5)"
                *ngIf="bindVariableService.shouldLoadTabs && bindVariableService.pageHasInputs">
                <ng-template tabHeading class="tab-heading">
                    <span class="bind-tab-labels">{{locale.LABEL_INPUT_PARAMS}}</span>
                </ng-template>
                <div class="wm-form">
                    <wms-bind-page-params *ngIf="bindVariableService.activeTab.index === (bindVariableService.isPrefabTemplate ? 6 : 5)"></wms-bind-page-params>
                </div>
            </tab>
        </tabset>
        <!--validation message div.To be styled-->
        <div class="validation-message media"
            [hidden]="!bindVariableService.validation[bindVariableService.currentTab]?.show">
            <div class="media-left">
                <i
                    class="validation-icon {{bindVariableService.validation[bindVariableService.currentTab]?.icon}} "></i>
            </div>
            <div class="media-body">
                <div>
                    <span
                        class="bold">{{bindVariableService.validation[bindVariableService.currentTab]?.message}}</span><br>
                </div>
                <div class="row">
                    <div class="col-md-1">
                        <span class="bold">{{locale.LABEL_PROPERTY_TARGET}}</span>
                        <span class="bold pull-right">:</span>
                    </div>
                    <div class="col-md-11">
                        <span class="bound-path">{{bindVariableService.activeProperty.name}}</span>&nbsp;
                        <span><i class="bound-type text-muted">{{bindVariableService.activeProperty.typeLabel ||
                                bindVariableService.activeProperty.type}}</i></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-1">
                        <span class="bold">{{locale.LABEL_BOUND_TO}}</span>
                        <span class="bold pull-right">:</span>
                    </div>
                    <div class="col-md-11">
                        <span class="bound-path"
                            title="{{bindVariableService.validation[bindVariableService.currentTab]?.boundExpression}}">{{bindVariableService.validation[bindVariableService.currentTab]?.boundExpression}}</span>&nbsp;
                        <span><i class="bound-type text-muted"
                                title="{{bindVariableService.validation[bindVariableService.currentTab]?.selectedVariableType}}">{{bindVariableService.validation[bindVariableService.currentTab]?.selectedVariableType}}</i></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="validation-warning-message"
            [hidden]="!bindVariableService.showWarning || bindVariableService.validation[bindVariableService.currentTab]?.show">
            <wms-message *ngIf="!showWarningMsg()" type="warning" hideclose="true" [scopeDataset]="bindVariableService.warningMessage"></wms-message>
        </div>
    </div>
  </ng-container>
  <ng-container *ngIf="appLocalManagerService.showNewLocaleMsgScreen">
    <div class="primary-panel locale-content full-width">
      <wms-message [scopeDataset]="appLocalManagerService.validationMessage"></wms-message>
        <div class="message-container full-height"> 
            <tabset class="message-tabs">
            <tab name="wm-locale-messages" >
                <ng-template tabHeading class="tab-heading">
                <span class="studio-tab-labels messages-label">{{locale.LABEL_MESSAGES}}</span>
                </ng-template>
            <wms-locale-messages-tab></wms-locale-messages-tab>
            </tab>
            </tabset>
        </div>
    </div>
  </ng-container>
</wms-dialog-body>
<wms-dialog-footer>
    <span *ngIf="bindVariableService.variableMode" class="hint-text pull-left" [innerHTML]="bindVariableService.bindVariableMessage"></span>
    <button name="wm-bindvariable-cancel" *ngIf="!bindVariableService.variableMode && !appLocalManagerService.showNewLocaleMsgScreen" class="btn app-button button-tertiary"
        (click)="onCancel($event)" title="{{locale.LABEL_CANCEL}}">{{locale.LABEL_CANCEL}}</button>
    <button name="wm-bindvariable-done" *ngIf="bindVariableService.variableMode && !appLocalManagerService.showNewLocaleMsgScreen" class="btn app-button button-secondary"
        (click)="onDone($event)" title="{{locale.LABEL_DONE}}">{{locale.LABEL_DONE}}</button>
    <button name="wm-bindvariable-unbind" *ngIf="bindVariableService.variableMode && !appLocalManagerService.showNewLocaleMsgScreen" class="btn app-button button-secondary"
        (click)="unBindVariable()" title="{{locale.LABEL_UNBIND}}"
        [disabled]="!bindVariableService.getBindingObjectFromList(bindVariableService.activeBindNode?.props?.bindTarget)?.value">{{locale.LABEL_UNBIND}}</button>
    <button name="wm-bindvariable-bind" [disabled]="bindVariableService.disableBind"  *ngIf="!appLocalManagerService.showNewLocaleMsgScreen"
        class="app-button btn button-primary" (click)="bindVariable()"
        title="{{locale.LABEL_BIND}}">{{locale.LABEL_BIND}}</button>
  <button name="wm-localMessage-back"  *ngIf="appLocalManagerService.showNewLocaleMsgScreen"
          class="app-button btn button-secondary" (click)="appLocalManagerService.closeModal()"
          title="{{locale.LABEL_BACK}}">{{locale.LABEL_BACK}}</button>
  <button name="wm-localeMessage-save" *ngIf="appLocalManagerService.showNewLocaleMsgScreen"
          class="app-button btn button-primary" (click)="appLocalManagerService.save(true)"
          title="{{locale.LABEL_SAVE}}">{{locale.LABEL_DONE}}</button>

</wms-dialog-footer>
